import React from 'react';
import { SalesFunnelDashboard } from './pages/SalesFunnelDashboard';
export function App() {
  return <SalesFunnelDashboard data-id="element-0" />;
}